import { css } from 'styled-components';
const ScopedCssBaseline = css(["box-sizing:border-box;font-family:var(--text-font-family);&:before,&:after{box-sizing:border-box;}"]);
export default ScopedCssBaseline;